export default "__VITE_ASSET__Hlst8hBD__"